import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/siteData';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h3 className="font-heading text-lg font-semibold text-background-50 mb-4">{siteConfig.name}</h3>
            <p className="text-sm text-background-400 leading-relaxed">{siteConfig.description}</p>
          </div>
          <div>
            <h4 className="font-label text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">首页</Link>
              <Link to="/category/zone-1" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">一区精选</Link>
              <Link to="/category/zone-2" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">二区精选</Link>
              <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">关于我们</Link>
            </div>
          </div>
          <div>
            <h4 className="font-label text-sm font-semibold text-background-50 mb-4">内容分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/hot" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">热门推荐</Link>
              <Link to="/category/latest" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">最新更新</Link>
              <Link to="/category/collection" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">精选合集</Link>
              <Link to="/category/guide" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">导航指南</Link>
            </div>
          </div>
          <div>
            <h4 className="font-label text-sm font-semibold text-background-50 mb-4">联系方式</h4>
            <div className="flex flex-col gap-2 text-sm text-background-400">
              <span>邮箱: contact@asiazone12.com</span>
              <span>微信: AsiaZone_Official</span>
              <span>服务时间: 9:00 - 21:00</span>
            </div>
          </div>
        </div>
        <div className="border-t border-background-700/50 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} {siteConfig.name}. 保留所有权利.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">使用条款</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">站点地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}